import type { Models } from 'appwrite';
import { Query } from 'appwrite';
import { databases } from './appWriteConfig';

export type Company = {
    companyId: string;
    companyName: string;
    domainName: string;
    active: boolean;
}

type CompanyDocument = Models.Document & {
    companyId?: string | number;
    companyName?: string;
    domainName?: string;
    active?: boolean;
}

export async function GetCompanies(): Promise<Company[]> {
    const databaseId = process.env.REACT_APP_APPWRITE_DATABASE_ID?.trim();
    const collectionId = process.env.REACT_APP_APPWRITE_COMPANIES_COLLECTION_ID?.trim();

    if (!databaseId || !collectionId) {
        throw new Error('Appwrite firma listesi ayarları eksik. Veritabanı ve firma koleksiyonu kimliklerini .env dosyasına ekleyin.');
    }

    const result = await databases.listDocuments<CompanyDocument>(databaseId, collectionId, [Query.limit(100)]);
    const companies = result.documents.filter(document => document.active === true).map(document => {
        const companyId = String(document.companyId ?? '').trim();
        const companyName = typeof document.companyName === 'string' ? document.companyName.trim() : '';
        const domainName = typeof document.domainName === 'string' ? document.domainName.trim() : '';

        if (!companyId || !companyName || !domainName) {
            throw new Error('Aktif firma kayıtlarında companyId, companyName ve domainName alanları bulunmalıdır.');
        }

        return { companyId, companyName, domainName, active: true };
    });

    if (companies.length === 0) {
        throw new Error('Appwrite firma koleksiyonunda seçilebilir firma bulunamadı.');
    }

    return companies.sort((first, second) => first.companyName.localeCompare(second.companyName, 'tr'));
}
